module.exports = __webpack_public_path__ + "img/icon_invite-copy.bce62a98.svg";